import { createZodDto } from 'nestjs-zod/dto';
import { z } from 'zod';
import { dateParser } from '#validation';
import { filespaceStatusParser } from '#validation/filespace';
export const filespaceResponseSchema = z.object({
    id: z.string(),
    workspaceId: z.string(),
    name: z.string(),
    subscriptionType: z.string(),
    storageOwner: z.string(),
    storageProviderId: z.string().nullish(),
    storageRegionId: z.string().nullish(),
    storageRegionName: z.string().nullish(),
    storageEndpoint: z.string(),
    storageBucket: z.string(),
    usedStorage: z.number(),
    usedNativeLayoutStorage: z.number().default(0),
    hubWebSocketEndpoints: z.array(z.string()),
    hubDataEndpoints: z.array(z.string()),
    discoveryServiceEndpoint: z.string(),
    legacyFilespaceName: z.string(),
    status: filespaceStatusParser,
    format: z.string(),
    //Note: left renameStatus property for backwards compatibility (older desktop client versions rely on this status)
    renameStatus: z.string().default('NeverRenamed'),
    createdAt: dateParser(),
    updatedAt: dateParser(),
    deletedAt: dateParser().nullish(),
    canRename: z.boolean().optional(),
    canDelete: z.boolean().optional(),
    canMigrate: z.boolean().optional(),
    isMigrating: z.boolean().optional(),
    settings: z.object({
        restrictWebAccess: z.boolean(),
        restrictMobileAccess: z.boolean(),
    }),
});
export class FilespaceResponseDto extends createZodDto(filespaceResponseSchema) {
}
